import type { HelpFile } from '../../types/help'
import { IdentityLifecycleHeaderTestIds } from '../../../testids/IdentityLifecycleHeaderTestIds'

export const identityLifecycleHeaderHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderSummary]:
      'Kompaktzusammenfassung des jüngsten Identitäts-Lebenszyklusereignisses — Zustandspaar, auslösende Quelle, Akteur, Zeitstempel und gekürzte Begründung.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderFromState]:
      'Vorheriger Lebenszyklus-Zustand vor diesem Übergang. Bei der initialen Erstellungszeile ausgeblendet.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderToState]:
      'Neuer Lebenszyklus-Zustand nach diesem Übergang. Die Erstellungszeile zeigt "Erstellt als <Zustand>", da kein fromState existiert.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderTriggerSource]:
      'Welcher Geschäftsprozess die Änderung ausgelöst hat (USER_ACTION, JML_LEAVER, EXIT_DATE_JOB usw.).',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderActor]:
      'Der ausführende Benutzer. Systemgesteuerte Übergänge zeigen "System"; der auslösende Prozess steht in der auslösenden Quelle.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderTimestamp]:
      'Relative Zeit des Übergangs. Per Hover wird der absolute Zeitstempel angezeigt.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderReason]:
      'Freitext-Begründung zum Zeitpunkt des Übergangs. Auf 80 Zeichen gekürzt; vollständiger Text per Hover.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderViewTimeline]:
      'Den vollständigen Reiter mit der Identitäts-Lebenszyklus-Zeitleiste öffnen, um alle Zustandsänderungen dieser Identität zu sehen.',
  },
}
